import { createContext } from "react";
import Terminal from "../data/model/Terminal";

export const TerminalModelContext = createContext<
  { terminal: Terminal } | undefined
>(undefined);
